import styled from 'styled-components';
import { classColor, groupColor, studentColor, STUDENT } from '../doughnuts-inner/doughnuts-inner-hooks';
import { flexDirection } from '../../styles/helpers/flexbox';

const DoughnutsWrapper = styled.div(() => `
  position: relative;
  width: 220px;
  margin-right: 20px;

  .doughnut-svg {
    position: relative;
    z-index: 10;
  }
`);

const ClassroomIconWrapper = styled.div(props => `
  position: absolute
  top: ${props.type === STUDENT ? 50 : 42}px;
  width: 100%;
  text-align: center;
  z-index: 5;
`);

const AttemptIconWrapper = styled.div(props => `
  position: absolute;
  top: ${props.type === STUDENT ? 95 : 105}px;
  width: 100%;
  text-align: center;
  z-index: 5;
`);

const PercentWrapper = styled.div(props => `
  position: absolute;
  top: ${props.type === STUDENT ? 65 : 60}px;
  width: 100%;
  text-align: center;
  z-index: 6;
  font-size: ${props.type === STUDENT ? 24 : 34}px;
  font-weight: bold;
  letter-spacing: -1px;
`);

const LegendWrapper = styled.div(props => `
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  ${props.type === STUDENT ? flexDirection('column') : ''}

  .legend-shell {
    display: flex;
    align-items: center;
    max-width: 100%;

    .color-indi {
      width: 20px;
      height: 20px;
      border-radius: 15px;
      flex-shrink: 0;
    }

    .text-indi {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  
    .class {
      background-color: ${classColor};
    }
  
    .group {
      background-color: ${groupColor};
    }

    .student {
      background-color: ${studentColor};
    }

    div[class*='svgIconComponent--'] {
      width: 30px;
      flex-shrink: 0;
    }

    ${props.type === STUDENT ? `
      &:not(:last-child) {
        margin-bottom: 10px;
      }
    ` : ''}
  }
`);

const StudentLegendShell = styled.div(props => `
  div[class*='svgIconComponent--'] {
    opacity: ${props.noStudentName ? 50 : 100}%;
  }

  .student-text {
    color: ${props.noStudentName ? '#959DA4' : 'inherit'};
  }
`);

export {
  DoughnutsWrapper,
  ClassroomIconWrapper,
  PercentWrapper,
  LegendWrapper,
  AttemptIconWrapper,
  StudentLegendShell
};
